<template>
    <div class="md-layout">
        <label class="md-layout-item md-size-20 md-form-label top_pad_min">
            {{amenity.name}}
        </label>
        <div class="md-layout-item">
            <md-radio v-for="option in amenity.details.options" v-model="amenity.details.modelRadio" :key="option" :value="option">{{option}}</md-radio>
            <FadeTransition :duration="400" mode="out-in" v-if="amenity.details.textShownAlways || amenity.details.modelRadio === amenity.details.textShownIfModelRadio">
                <md-field>
                    <md-input type="text" v-model="amenity.details.modelText" :placeholder="amenity.details.placeholder" />
                    <span class="md-helper-text">{{amenity.details.help}}</span>
                </md-field>
            </FadeTransition>
        </div>
    </div>
</template>
<script>
    import { FadeTransition } from "vue2-transitions";

    export default {
        name: "AmenityRadioText",
        components: {
            FadeTransition
        },
        props: {
            amenity: null
        }
    };
</script>
<style>
   
</style>
